// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"idatacourse-table-dark_tableWrapper__2n2fz"};